import { TViewModifierAction, ViewModifierActionTypes } from './viewModifierActions';
import { IViewModifierState } from './viewModifierContext';

export const viewModifierReducer = (state: IViewModifierState, action: TViewModifierAction): IViewModifierState => {
	switch (action.type) {
		case ViewModifierActionTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetchData,
			};
		case ViewModifierActionTypes.REFETCH_REST_PROPS_DATA:
			return {
				...state,
				needRefetchRestPropsData: action.payload.needRefetchRestPropsData,
			};
		case ViewModifierActionTypes.REFETCH_PORTIONS_DATA:
			return {
				...state,
				needRefetchRestaurantPortionsData: action.payload.needRefetchRestaurantPortionsData,
			};
		case ViewModifierActionTypes.SET_MODIFIER_FULL_INFO:
			return {
				...state,
				modifierFullInfo: action.payload.modifierFullInfo,
				accessibleRestaurants: action.payload.accessibleRestaurants,
				accessiblePortionsRestaurants: action.payload.accessiblePortionsRestaurants,
			};
		case ViewModifierActionTypes.SET_RESTAURANT_ID_FOR_RESTAURANT_PROPS:
			return {
				...state,
				restaurantIdForRestaurantProps: action.payload.restaurantIdForRestaurantProps,
				restaurantProps: action.payload.restaurantProps,
			};
		case ViewModifierActionTypes.SET_RESTAURANT_PROPS:
			return {
				...state,
				restaurantProps: action.payload.restaurantProps,
			};
		case ViewModifierActionTypes.SET_RESTAURANT_ID_FOR_PORTIONS:
			return {
				...state,
				restaurantIdForPortions: action.payload.restaurantIdForPortions,
				restaurantPortions: action.payload.restaurantPortions,
			};
		case ViewModifierActionTypes.SET_RESTAURANT_PORTIONS:
			return {
				...state,
				restaurantPortions: action.payload.restaurantPortions,
			};
		case ViewModifierActionTypes.CHANGE_SELECTED_PORTION_ID:
			return {
				...state,
				selectedPortionId: action.payload.selectedPortionId,
			};
		case ViewModifierActionTypes.SET_TRANSLATION_TAB:
			return {
				...state,
				selectedTranslationTab: action.payload.selectedTranslationTab,
			};
		case ViewModifierActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		default:
			return state;
	}
};
